<template>
  <section id="quran" class="py-24 bg-white relative">
    <div class="max-w-7xl mx-auto px-6">
      <UiSectionHeading
        v-reveal
        :eyebrow="t('quran.landing.studyEyebrow')"
        eyebrow-icon="solar:book-bookmark-linear"
        :title="t('quran.landing.studyTitle')"
        :subtitle="t('quran.landing.studySubtitle')"
        class="mb-16"
      />

      <div class="grid gap-6 md:grid-cols-2">
        <UiCard
          v-for="(card, i) in cards"
          :key="card.to"
          v-reveal="{ delayMs: i * 80 }"
          :to="card.to"
          tone="mist"
          padding="lg"
          radius="xl"
          class="group flex flex-col"
        >
          <span class="w-12 h-12 rounded-2xl bg-deen-gold/30 text-deen-ink flex items-center justify-center mb-6">
            <iconify-icon :icon="card.icon" class="text-2xl" aria-hidden="true" />
          </span>
          <h3 class="font-display text-2xl font-semibold text-deen-ink tracking-tight mb-2">{{ card.title }}</h3>
          <p class="text-deen-ink/60 font-medium leading-relaxed mb-6">{{ card.body }}</p>
          <span class="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-deen-ink">
            {{ card.cta }}
            <iconify-icon icon="solar:arrow-right-linear" class="group-hover:translate-x-1 transition-transform" aria-hidden="true" />
          </span>
        </UiCard>
      </div>

      <UiCard v-reveal tone="sand" padding="lg" radius="xl" class="mt-6 grid lg:grid-cols-[1fr_auto] gap-6 items-center">
        <div>
          <p class="font-display text-2xl font-semibold text-deen-ink mb-2">{{ t('quran.index.wordsTitle') }}</p>
          <p class="text-deen-ink/60 font-medium mb-5 max-w-2xl">{{ t('quran.index.wordsBody') }}</p>
          <WordExamples />
        </div>
        <UiButton :to="wordsPath()" size="lg" trailing-icon="solar:arrow-right-linear">{{ t('quran.index.wordsCta') }}</UiButton>
      </UiCard>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import WordExamples from '@/components/quran/WordExamples.vue';
import UiButton from '@/components/ui/UiButton.vue';
import UiCard from '@/components/ui/UiCard.vue';
import UiSectionHeading from '@/components/ui/UiSectionHeading.vue';
import { localizedQuranPath, wordsPath } from '@/utils/quran/paths';

const { t, tm } = useI18n();

const cards = computed(() => tm('quran.landing.cards').map((card) => ({ ...card, to: localizedQuranPath(card.to) })));
</script>
